import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { VisitorCountProvider } from './context/VisitorCounterContext';
import ProtectedRoute from './Components/ProtectedRoute';

// Public Pages
import Home from './pages/Home';
import Projects from './pages/Projects';
import Research from './pages/Research';
import Blogs from './pages/Blogs';
import BlogPost from './pages/Blogpost';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/Admindashboard';

// Admin Pages
import AdminProjects from './pages/admin/AdminProjects';
import ProjectEditor from './pages/admin/ProjectEditor';
import AdminBlogs from './pages/admin/AdminBlogs';
import BlogEditor from './pages/admin/BlogEditor';
import AdminResearch from './pages/admin/AdminResearch';
import ResearchEditor from './pages/admin/ResearchEditor';
import AdminProfile from './pages/admin/AdminProfile';
import AdminEducation from './pages/admin/AdminEducation';
import EducationEditor from './pages/admin/EducationEditor';
import AdminExperience from './pages/admin/AdminExperience';
import ExperienceEditor from './pages/admin/ExperienceEditor';
import AdminInvolvements from './pages/admin/Admininvolvements';
import InvolvementEditor from './pages/admin/Involvementeditor';
import AdminAwards from './pages/admin/Adminawards';
import AwardEditor from './pages/admin/Awardseditor';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/research" element={<Research />} />
      <Route path="/writings" element={<Blogs />} />
      <Route path="/writings/:slug" element={<BlogPost />} />

      {/* Admin Routes */}
      <Route path="/adminaccess" element={<AdminLogin />} />
      <Route
        path="/adminaccess/dashboard"
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      {/* Profile Management Routes */}
      <Route
        path="/adminaccess/profile"
        element={
          <ProtectedRoute>
            <AdminProfile />
          </ProtectedRoute>
        }
      />

      {/* Education Management Routes */}
      <Route
        path="/adminaccess/education"
        element={
          <ProtectedRoute>
            <AdminEducation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/education/new"
        element={
          <ProtectedRoute>
            <EducationEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/education/edit/:id"
        element={
          <ProtectedRoute>
            <EducationEditor />
          </ProtectedRoute>
        }
      />

      {/* Experience Management Routes */}
      <Route
        path="/adminaccess/experience"
        element={
          <ProtectedRoute>
            <AdminExperience />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/experience/new"
        element={
          <ProtectedRoute>
            <ExperienceEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/experience/edit/:id"
        element={
          <ProtectedRoute>
            <ExperienceEditor />
          </ProtectedRoute>
        }
      />

      {/* Involvements Management Routes */}
      <Route
        path="/adminaccess/involvements"
        element={
          <ProtectedRoute>
            <AdminInvolvements />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/involvements/new"
        element={
          <ProtectedRoute>
            <InvolvementEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/involvements/edit/:id"
        element={
          <ProtectedRoute>
            <InvolvementEditor />
          </ProtectedRoute>
        }
      />

      {/* Awards Management Routes */}
      <Route
        path="/adminaccess/awards"
        element={
          <ProtectedRoute>
            <AdminAwards />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/awards/new"
        element={
          <ProtectedRoute>
            <AwardEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/awards/edit/:id"
        element={
          <ProtectedRoute>
            <AwardEditor />
          </ProtectedRoute>
        }
      />

      {/* Project Management Routes */}
      <Route
        path="/adminaccess/projects"
        element={
          <ProtectedRoute>
            <AdminProjects />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/projects/new"
        element={
          <ProtectedRoute>
            <ProjectEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/projects/edit/:id"
        element={
          <ProtectedRoute>
            <ProjectEditor />
          </ProtectedRoute>
        }
      />

      {/* Blog Management Routes */}
      <Route
        path="/adminaccess/writings"
        element={
          <ProtectedRoute>
            <AdminBlogs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/writings/new"
        element={
          <ProtectedRoute>
            <BlogEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/writings/edit/:id"
        element={
          <ProtectedRoute>
            <BlogEditor />
          </ProtectedRoute>
        }
      />

      {/* Research Management Routes */}
      <Route
        path="/adminaccess/research"
        element={
          <ProtectedRoute>
            <AdminResearch />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/research/new"
        element={
          <ProtectedRoute>
            <ResearchEditor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/adminaccess/research/edit/:id"
        element={
          <ProtectedRoute>
            <ResearchEditor />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <VisitorCountProvider>
          <AppRoutes />
        </VisitorCountProvider>
      </Router>
    </AuthProvider>
  );
};

export default App;